import { render, staticRenderFns } from "./twoInfoButtonsDynamic.vue?vue&type=template&id=7bddff13&"
import script from "./twoInfoButtonsDynamic.vue?vue&type=script&lang=js&"
export * from "./twoInfoButtonsDynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports